module.exports = __webpack_public_path__ + "static/media/mainteinance.2f722db6.svg";